import { Component } from '@angular/core';

import { Platform, LoadingController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { tap } from "rxjs/operators";
import { UserService } from './service/user.service';

import { Storage } from '@capacitor/storage';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Network } from '@capacitor/network';
import { Device, DeviceInfo } from '@capacitor/device';

import { BootService } from './service/boot.service';

import { Router } from '@angular/router';

import firebase from 'firebase/app';
import 'firebase/auth';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  loading: any;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    public loadingCtrl: LoadingController,
    public firestore: AngularFirestore,
    public navCtrl: NavController,
    private router: Router,
    public userService: UserService,
    private bootService: BootService
  ) {
    this.initializeApp();
  }
  initializeApp() {
    this.platform.ready().then(async () => {
      // Firebase automatic authentication
      this.listenToUserStatusUpdate();

      // Boot the bootService
      this.bootService.boot()

      // Check user connection and tune navigation accordingly
      this.setupFirstScreen()
      
      // GEtting selected language from previous session
      this.translate.setDefaultLang('fr');
      const {value} = await Storage.get({key: "NOUMO_CONSUMER_LANGUAGE"})
      if (value !== null) {
        this.translate.setDefaultLang(value);
        this.translate.use(value)
        this.bootService.selectedLanguage = value
      } else {
        const languageCodeResult = await Device.getLanguageCode()
        console.log ("languageCodeResult value", languageCodeResult.value)
        const language: string = (languageCodeResult.value.includes('fr') || languageCodeResult.value.includes('en') || languageCodeResult.value.includes('cn')) ? languageCodeResult.value.substring(0, 2) : 'en'
        console.log ("language value", language)
        this.translate.use(language);
        this.bootService.selectedLanguage = language
      }
    });
  }

  // Check user connection and tune navigation accordingly
  async setupFirstScreen() {
    console.log("--- setupFirstScreen ---");

    // Check if the network status is online
    const { connected } = await Network.getStatus();
    console.log ("connected to the network", connected)

    // Getting device platform
    const info: DeviceInfo = await Device.getInfo();
    const devicePlatform = info.platform
    console.log ("devicePlatform", devicePlatform)

    // Check if user already logged in in the past
    const { value } = await Storage.get({key: 'USER_EXIST'})
    if (value === null || !connected) {
      // No trace of any passed login then go to intro
      await this.navCtrl.navigateRoot("/intro");
      // SplashScreen.hide();
      if (devicePlatform !== 'web') {
        setTimeout(() => {
          SplashScreen.hide();

          // Default statusBar style depending on dark/light mode selected by the user
          StatusBar.setStyle({ style: Style.Default });
          StatusBar.show();
        }, 1000)
      }
    } else {
      // A user previously logged in with this phone, go to home
      await this.navCtrl.navigateRoot("/home");
      // SplashScreen.hide();
      if (devicePlatform !== 'web') {
        setTimeout(() => {
          SplashScreen.hide();

          // Default statusBar style depending on dark/light mode selected by the user
          StatusBar.setStyle({ style: Style.Default });
          StatusBar.show();
        }, 1000)
      }

      // Log in silently with listenToUserStatusUpdate
      // this.listenToUserStatusUpdate()
    }
  }

  async listenToUserStatusUpdate() {
    console.log("--- listenToUserStatusUpdate ---");
    
    firebase.auth().onAuthStateChanged(user => {
      console.log("Firebase user after automatic login", user);
      if (user) {
        console.log ("Firebase user logged in", user.uid)

        this.firestore
          .collection("consumers/")
          .doc(user.uid).get()
          .subscribe(async res => {
            console.log("LoginRes", res);
            // if (this.loading) 
            // this.loading.dismiss();

            // Hide the splash (you should do this on app launch)
            /*
            setTimeout(() => {
              SplashScreen.hide();
            }, 1000)
            */

            if (res.exists) {
              console.log("--- User EXIST > MENU ---");

              // Fill consumer informations (favorites, addresses)
              this.userService.fillUserInfo(res.data(), user.uid)

              // Log user agent with a firebase log functions
              this.userService.logUserAgent()

              // Store user exist information to local storage
              Storage.set({ key: 'USER_EXIST', value: res.id });
              
              //GetOrder Data
              this.userService.getOrders()

              // Check permission and register push notifications in order to send updates about the order
              if (this.bootService.devicePlatform !== "web")
                this.bootService.requestPushPermissions()

              // Navigate to home if the current page is authPhone
              console.log('this.router.url', this.router.url);
              if (this.router.url === "/authphone" || this.router.url === "/authconfirm") {
                console.log ("hasNotEnteredSmsCodeYet", this.bootService.hasNotEnteredSmsCodeYet)
                if (this.bootService.hasNotEnteredSmsCodeYet) {
                  // Android authenticate automatically with the SMS without the user need to enter it
                  this.loading = await this.loadingCtrl.create({message: await this.translate.get('ANDROID_AUTO_AUTH_MESSAGE').toPromise()});
                  this.loading.present();

                  setTimeout(async () => {
                    await this.navCtrl.navigateRoot("/home");
                    this.loading.dismiss();
                  }, 3000)
                } else
                  this.navCtrl.navigateRoot("/home");
              }
            } else {
              console.log("--- User not exist > SETUP NAME + EMAIL ---");
              console.log('this.router.url', this.router.url);
              // Navigate to firstsetup if the current page is authPhone
              if (this.router.url === "/authphone" || this.router.url === "/authconfirm") {
                console.log ("hasNotEnteredSmsCodeYet", this.bootService.hasNotEnteredSmsCodeYet)
                if (this.bootService.hasNotEnteredSmsCodeYet) {
                  // Android authenticate automatically with the SMS without the user need to enter it
                  this.loading = await this.loadingCtrl.create({message: await this.translate.get('ANDROID_AUTO_AUTH_MESSAGE').toPromise()});
                  this.loading.present();

                  setTimeout(async () => {
                    await this.navCtrl.navigateRoot("/firstsetup");
                    this.loading.dismiss();
                  }, 2000)
                } else
                  this.navCtrl.navigateRoot("/firstsetup");
              }
            }
          });
      } else {
        // if (this.loading)
        // this.loading.dismiss();
        // Hide the splash (you should do this on app launch)
        // SplashScreen.hide();

        // this.navCtrl.navigateRoot("/intro");
      }
    });
  }
}
